import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import DraggableModal from '../DraggableModal';

export default function ModalConfirm(props) {
  const {
    onClose, onConfirm, headerText, message, access, id,
  } = props;
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    const success = await onConfirm();
    if (success) onClose();
    setLoading(false);
  };

  return (
    <DraggableModal show headerNode={headerText} onHide={onClose}>

      {message && (
        <Modal.Body>
          <p>{ message }</p>
        </Modal.Body>
      )}

      <Modal.Footer>
        <Button
          onClick={onClose}
          variant="outline-secondary"
          disabled={loading}
        >
          Отмена
        </Button>
        <Button
          onClick={handleConfirm}
          variant={props.confirmBtnVariant || 'primary'}
          disabled={loading}
        >
          {props.confirmBtnText || 'Да'}
        </Button>
      </Modal.Footer>
    </DraggableModal>
  );
}
